import { Card, Checkbox, InputNumber } from "antd";
import BbotButton from "top-component-library/BbotButton";

import { Section, SettingRow } from "../styles";
import { toCents } from "../utils";

// Admin-only controls for how a customer is billed for SMS. Values are stored on the trove in
// cents; the free-credit input is shown in dollars.
const AdminSmsSettingsCard = ({ trove, saving, onUpdateField, onSave }) => (
  <Section>
    <Card title="Customer SMS Settings">
      <SettingRow>
        <Checkbox checked={trove.charge_for_sms} onChange={(e) => onUpdateField("charge_for_sms", e.target.checked)}>
          Charge this customer for SMS messaging rates
        </Checkbox>
      </SettingRow>
      <SettingRow>
        <Checkbox
          checked={trove.allow_negative_balance}
          onChange={(e) => onUpdateField("allow_negative_balance", e.target.checked)}
        >
          Allow SMS messaging if the balance drops below $0.00
        </Checkbox>
      </SettingRow>
      <SettingRow>
        <span>Monthly free credit amount: $</span>
        <InputNumber
          id="tmm-free-credit"
          min={0}
          step={0.01}
          value={trove.free_credit_cents / 100}
          onChange={(value) => onUpdateField("free_credit_cents", toCents(value))}
        />
      </SettingRow>
      <BbotButton type="primary" loading={saving} onClick={onSave}>
        Save
      </BbotButton>
    </Card>
  </Section>
);

export default AdminSmsSettingsCard;
